import React, { createContext, useState } from 'react';

const CacheContextMoto = createContext();

export const CacheMotoProvider = ({ children }) => {
		const [cache, setCache] = useState(JSON.parse(sessionStorage.getItem("cacheMoto")) || {});

	const setCacheCustom = () => {
		sessionStorage.setItem("cacheMoto", JSON.stringify(cache))
	}

	const clearCacheMoto = () => {
		setCache({})
	}

	return (
		<CacheContextMoto.Provider value={{ cache, setCache, setCacheCustom, clearCacheMoto }}>
			{children}
		</CacheContextMoto.Provider>
	);
};

export default CacheContextMoto;
